module.exports = __webpack_public_path__ + "media/images/flags/4x3/mac-df6917fd173e3e581774225102c370b3.svg";